<p-toast [life]="constantService.defaultToastLife"></p-toast>
<div (mouseleave)="mouseOut('mainwindow')" class="main-container nopadding">
	<router-outlet></router-outlet>
</div>